export default {
  types: {
    _primaryControls: {
      width: '3rem',
      name: 'เมนู',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    name: {
      name: 'หมวดหมู่',
      width: '1fr',
    },
    total_items: {
      name: 'จำนวนรายการชิ้นส่วนในระบบ',
      width: '12rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
    },
  },

};
